import React from 'react';
import { useParams } from 'react-router-dom';
import WorkPageTemplate from '../../components/work/WorkPageTemplate';
import { loadAiProjectData, getAiNavigation } from '../../utils/workUtils';

const AIProjectPage = () => {
  const { id } = useParams();
  return (
    <WorkPageTemplate id={id} loadDataFn={loadAiProjectData} getNavigationFn={getAiNavigation} />
  );
};

export default AIProjectPage;

